import { Component, EventEmitter, Input, Output } from '@angular/core';
import { employeeStatusInfo } from 'src/app/shared/data/employee-status.enum';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { filter, finalize, switchMap } from 'rxjs/operators';
import { interceptorAvisouErro } from 'src/app/shared/http-interceptor/http-interceptor.module';
import { EMessageType } from 'src/app/shared/data/response-default.interface';
import { ModalConfirmacaoService } from 'src/app/shared/services/modal-confirmacao.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { ICadastroEmployee } from '../../models/employee';
import { EmployeeService } from '../../services/employee.service';

@Component({
  selector: 'app-list-employees',
  templateUrl: './list-employees.component.html',
  styleUrls: ['./list-employees.component.scss']
})
export class ListEmployeesComponent {
  ERoleAdminString = ERoleAdminString;
  readonly statusInfo = employeeStatusInfo;
  readonly deletePermissions = [ERoleAdminString.Admin, 'employee.disable'];
  @Output() mudouPagina = new EventEmitter<number>();
  @Output() mudouTamanhoPagina = new EventEmitter<number>();
  @Output() recarregarListagem = new EventEmitter();
  @Input() employers: ICadastroEmployee[] = [];
  @Input() dadosPaginacao: {
    paginaSelecionada: number;
    tamanhoPagina: number;
    totalPaginas: number;
    itensTotal: number;
  } = {
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };

  detalhesColaboradorId?: string;
  modalDetalhesAberto = false;

  constructor(
    private readonly modalConfirmacao: ModalConfirmacaoService,
    private readonly employeeService: EmployeeService,
    private readonly toastService: ToastService
  ) {}

  public abrirDetalhes(colaboradorId: string): void {
    this.detalhesColaboradorId = colaboradorId;
    this.modalDetalhesAberto = true;
  }

  public fecharDetalhes(): void {
    this.modalDetalhesAberto = false;
    this.detalhesColaboradorId = undefined;
  }

  /**
   * Exclusão lógica (Active = false): o colaborador sai de todas as listas e relatórios e perde o
   * acesso ao totem e à carteirinha. A ação não tem volta.
   */
  excluindo = false;

  public excluir(employee: ICadastroEmployee): void {
    // Dois cliques rápidos abririam dois modais e duas exclusões.
    if (this.excluindo) return;
    this.excluindo = true;

    const mensagem = `Excluir ${employee.name}? O colaborador sai de todas as listas e relatórios e perde o acesso ao totem e à carteirinha de saúde. Essa ação não pode ser desfeita.`;

    this.modalConfirmacao
      .abrirModalConfirmacao({ mensagem })
      .pipe(
        filter((confirmou) => confirmou),
        switchMap(() => this.employeeService.desativarColaborador(employee.id!)),
        finalize(() => (this.excluindo = false))
      )
      .subscribe({
        next: (resposta) => {
          if (resposta.messages && resposta.messages.length > 0) {
            this.toastService.toast(resposta.messages);
          }

          if (resposta.isSucceed) {
            this.recarregarListagem.emit();
          }
        },
        error: (erro) => {
          if (!interceptorAvisouErro(erro)) {
            this.toastService.toast('Erro ao excluir o colaborador. Tente novamente.', EMessageType.Error);
          }
        }
      });
  }
}
